import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const UpdateStudentProfileMutation = graphql.persisted(
  "UpdateStudentProfile",
  graphql(`
    mutation UpdateStudentProfile(
      $studentProfileId: ID!
      $medicalInfo: StudentMedicalInfoInput
      $adminMetadata: StudentAdminMetadataInput
    ) {
      updateStudentProfile(input: {
        studentProfileId: $studentProfileId
        medicalInfo: $medicalInfo
        adminMetadata: $adminMetadata
      }) {
        studentProfile {
          id
          dateOfBirth
          medicalInfo {
            medicalCondition
            otcMedicationPermission
            otcMedicationsApproved {
              acetaminophen
              ibuprofen
              coughDrops
              other
            }
            specialNeeds
            insuranceInfo {
              carrier
              groupNumber
              policyNumber
              policyHolderName
            }
          }
          adminMetadata {
            adminNotes
            academicProbation
            behavioralProbation
            pauseAutoReenroll
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateStudentProfileMutation };

export function useUpdateStudentProfileMutation() {
  return useMutation(UpdateStudentProfileMutation);
}
